import React, { useState } from "react";

import { mdiTrashCanOutline } from "@mdi/js";
import Icon from "@mdi/react";

import Button from "../../button/Button";
import ConfirmModal from "../../modal/ConfirmModal";

interface CardDeleteButtonProps {
  title: string;
  message: React.ReactNode;
  confirmLabel: string;
  cancelLabel: string;
  onDelete: () => void;
}

export default function CardDeleteButton({
  title,
  message,
  confirmLabel,
  cancelLabel,
  onDelete,
}: CardDeleteButtonProps): React.JSX.Element {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  return (
    <React.Fragment>
      <Button
        className="text-muted-foreground hover:text-destructive hover:light:bg-red-50 border-0"
        onClick={(): void => setIsConfirmOpen(true)}
        size="xs"
        type="button"
        variant="secondary"
      >
        <Icon path={mdiTrashCanOutline} size={0.75} />
      </Button>
      <ConfirmModal
        iconPath={mdiTrashCanOutline}
        isOpen={isConfirmOpen}
        onClose={(): void => setIsConfirmOpen(false)}
        title={title}
        actions={[
          {
            label: cancelLabel,
            buttonVariant: "secondary",
            onClick: (): void => setIsConfirmOpen(false),
          },
          {
            label: confirmLabel,
            buttonVariant: "delete",
            onClick: onDelete,
          },
        ]}
      >
        {message}
      </ConfirmModal>
    </React.Fragment>
  );
}
